// Google Consent Mode v2 helpers

export const CONSENT_KEY = 'auronixio_consent_v1';

export const defaultConsent = {
  essential: true,
  functionality: true,
  analytics: false,
  marketing: false,
  personalization: false,
};

function ensureGtag() {
  if (typeof window === 'undefined') return () => {};
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }
  return window.gtag;
}

export function getStoredConsent() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (e) {
    return null;
  }
}

export function applyConsentToGtag(consent) {
  const gtag = ensureGtag();
  const payload = {
    ad_storage: consent.marketing ? 'granted' : 'denied',
    ad_user_data: consent.marketing ? 'granted' : 'denied',
    ad_personalization: consent.marketing ? 'granted' : 'denied',
    analytics_storage: consent.analytics ? 'granted' : 'denied',
    functionality_storage: consent.functionality ? 'granted' : 'denied',
    personalization_storage: consent.personalization ? 'granted' : 'denied',
    security_storage: 'granted',
  };
  gtag('consent', 'update', payload);
  window.dataLayer.push({ event: 'cookie_consent_update', consent: payload });
}

export function saveConsent(consent) {
  const value = { ...defaultConsent, ...consent, essential: true };
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify(value));
  }
  applyConsentToGtag(value);
  return value;
}

export function openConsentPreferences() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('auronixio:open-cookie-preferences'));
}

export function reHydrateOnLoad() {
  const stored = getStoredConsent();
  if (stored) applyConsentToGtag(stored);
}
